import { Box } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import { ReactSvg } from '../../../shared/vector-images';

interface HeaderBarButtonProps {
  icon: any;
  ariaLabel?: string;
  desktopOnly?: boolean;
  large?: boolean;
  onClick: () => void;
  className?: string;
}

const HeaderBarButton: FC<HeaderBarButtonProps> = ({
  icon,
  onClick,
  ariaLabel,
  desktopOnly,
  large,
  className,
}) => {
  const theme = useTheme();

  const boxSize = large ? '50px' : '40px';
  const iconSize = large ? 40 : 36;

  return (
    <Box
      key="button-close"
      onClick={onClick}
      display={desktopOnly ? ['none', 'none', 'flex'] : 'flex'}
      alignItems="center"
      justifyContent="center"
      width={boxSize}
      height={boxSize}
      role="link"
      aria-label={ariaLabel}
      className={className}
    >
      <ReactSvg
        toDisplay={icon}
        options={{
          fillColor: theme.colors.primary,
        }}
        width={iconSize}
        height={iconSize}
      />
    </Box>
  );
};

HeaderBarButton.defaultProps = {
  ariaLabel: undefined,
  desktopOnly: false,
  large: false,
  className: undefined,
};

export default HeaderBarButton;
